import { render, staticRenderFns } from "./DetallesTarjeta.vue?vue&type=template&id=30386cf8&"
import script from "./DetallesTarjeta.vue?vue&type=script&lang=js&"
export * from "./DetallesTarjeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports